<script>
import Layout from "../../layouts/main";
import appConfig from "@/app.config";
import Loader from "@/components/widgets/loader";
import apibtoast from "@/helpers/apibtoast";
import apigeneric from "@/helpers/apigeneric";
import Banner from "../components/banner";

export default {
  mixins: [apibtoast, apigeneric],
  page: {
    title: "Web Siteleri",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Loader,
    Layout,
    Banner,
  },
  data() {
    return {
      TableData: {},
      NewsId: this.$route.params.NewsId,
      LangId: this.$route.params.LangId,
      News:{},
      OtherNewsTitle: {},
      DefaultPage: 1,
      Page: {
        PageNumber: "1",
        PageSize: "10",
        PageDataSize: "1",
      },

    };
  },
  methods: {
    getFirstImage(gallery) {
      if (gallery) {
        return gallery.split(',')[0].trim();
      }
      return '';
    },
    getImageArray(gallery) {
      if (gallery) {
        return gallery.split(',').map(img => img.trim()).filter(img => img !== '');
      }
      return [];
    },
    Get() {
      if(this.LangId=="tr" || this.LangId== null){
      this.ActionsSingleGet({
        Service: "news",
        Id: this.NewsId,
      }).then((res) => {
        this.TableData = res.Data;
        
      });
    }else{
      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
       "&shortlangtitle="+this.LangId
      }).then((res) => {
        for(let LangData in res.Data){
          this.ActionsFilterGet({
          Service: "newstranslations",
          Page: this.Page,
          Filter: "&Langid="+ res.Data[LangData].Id + "&Newsid=" + this.NewsId
        }).then((res) => {
          this.TableData = res.Data[0];
          if(res.TotalCount == 0){
              localStorage.setItem("lang", "tr");
              window.location.reload();
              
            }
        
      });
        }
      });

      
    }

       let Page = {
      PageNumber: "1",
      PageSize: "10",
      PageDataSize: "1", 
    };
      this.ActionsFilterGet({
        Service: "news",
        Page: Page,
        Filter:"&Desc=Created"
      }).then((res) => {
        this.News = res.Data;
        
      });

      this.ActionsFilterGet({
        Service: "languages",
        Page: this.Page,
        Filter:
          "&shortlangtitle=" + this.LangId
      }).then((res) => {
        for (let LangData in res.Data) {
          this.ActionsFilterGet({
            Service: "LanguagereSources",
            Page: this.Page,
            Filter: "&Langid=" + res.Data[LangData].Id + "&Resourceid=cb87bbbe-77e2-4ddb-bebe-54491edfd6b7"
          }).then((res) => {
            this.OtherNewsTitle = res.Data;
            if (res.TotalCount == 0) {
              localStorage.setItem("lang", "tr");
              window.location.reload();
            }
          });
        }
      });
    },
  },
};
</script>

<template>
  <Loader>
    <Layout>
      <Banner />

      <div class="news-detail"> 
        <div class="container">
            <div class="row">
                <div class="col-md-8">
                    <div class="news">
                        <div class="image">
                            <b-carousel
                                id="carousel-news"
                                v-if="getImageArray(TableData.Imagegallery).length > 1"
                                :interval="4000"
                                controls
                                indicators
                                background="#ababab"
                                style="text-shadow: 1px 1px 2px #333;"
                            >
                                <b-carousel-slide v-for="(img, index) in getImageArray(TableData.Imagegallery)" :key="index" :img-src="$config.FILES_URL + 'web/' + img"></b-carousel-slide>
                            </b-carousel>
                            <img v-else-if="getImageArray(TableData.Imagegallery).length === 1" :src="$config.FILES_URL + 'web/' + getImageArray(TableData.Imagegallery)[0]" alt="">
                        </div>
                        <div class="new-header">
                            <div class="type">
                                akademik
                            </div>
                            <div class="new-date">
                                <span class="date">{{TableData.Startdate | formatDateTime }}</span>
                            </div>
                        </div>
                        <div class="new-title">{{News.Title}}
                            <h2>{{TableData.Title}}</h2>
                        </div>
                        <div class="new-content">
                            <span v-html="TableData.Description"></span><br />
                        </div>
                        <div class="author" v-if="1 == 2">
                            <span class="name">{{TableData.Createdby}}</span>
                        </div>
                    </div>
                </div>
                <div class="col-md-4">
                    <div class="news-title">
                        <p>{{OtherNewsTitle[0].Resourcevalue}}</p>
                    </div>
                    <div class="news-link">
                        <div class="item" v-for="Data in News" :key="Data.Id">
                            <div class="row">
                                <div class="col-md-3">
                                    <img :src="$config.FILES_URL + 'web/' + getFirstImage(Data.Imagegallery)" alt="">
                                </div>
                                <div class="col-md-9">
                                    <a :href="'/NewsDetail/'+ LangId + '/' + Data.Title.toLowerCase()
                                    .replace(/I|İ/gi, 'i')
                                    .replace(/Ğ|ğ/gi, 'g')
                                    .replace(/Ç|ç|ğ/gi, 'c')
                                    .replace(/\s+/g, '-')
                                    .replace(/&/g, `-and-`)
                                    .replace(/--/g, `-`) + '/'
                 + Data.Id" class="item-link">
                                        <span v-html="Data.Description"></span><br />
                                    </a>
                                </div>
                            </div>
                        </div>
                     </div>
                </div>
            </div>
        </div>
    </div>
    </Layout>
  </Loader>
</template>
